import { styled } from "goober";

export const ScopeDot = styled("span")`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
`;
